import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  Col,
  Container,
  Row,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate, useParams } from "react-router-dom"
import {
  fetchRevisions,
  updateRevisionStatus,
} from "../../../services/estimation/estimation"
import { toastSuccess } from "../../../helpers/msg_helper"
import downloadicon from "../../../assets/icons/download.svg"
import Logo from "../../../assets/images/logo.svg"
import { samplePdfFileDownload } from "../../../services/Inventory/inventory"
import {
  downloadpo,
  fetchPurchase,
  fetchPurchaseOrderVoucher,
} from "../../../services/procurement/purchaseOrder"
import parse from "html-react-parser"
import phoneIcon from "../../../assets/icons/phone.svg"
import webIcon from "../../../assets/icons/website.svg"
import locationIcaon from "../../../assets/icons/location.svg"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { R } from "@table-library/react-table-library/index-a318de9b"
import NumberFormat from "../../../utils/numberFormat"

const ViewPurchaseOrderVoucher = ({ fromDashboard, viewValue }) => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Purchase Order${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const navigate = useNavigate()

  const [revision, setRevisions] = useState()
  const [refresh, setRefresh] = useState(0)
  const [revisionType, setRevisionType] = useState({ index: "", status: false })
  const { id } = useParams()

  const fullUrl = window.location.pathname

  const viewId = fromDashboard ? viewValue?.value?.id : id

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const imgUrl = process.env.REACT_APP_IMG_APIKEY

  let payTerms
  useEffect(() => {
    const fetchData = async id => {
      const response = await fetchPurchaseOrderVoucher(id)
      setRevisions(response?.data)
      payTerms = response?.data?.pay_terms
      console.log("response?.data?.length :", response?.data?.length)
      setOpen(response?.data?.length == 1 ? 0 : "")
    }
    fetchData(viewId)
  }, [refresh])

  const handleRevisionDownload = ({ id, type }) => {
    const handleCommonExport = async id => {
      const response = await samplePdfFileDownload(
        type == "short"
          ? `estimation/pdf-mini-statement/${id}`
          : `estimation/pdf/${id}`
      )
    }
    handleCommonExport(id)
  }

  const [open, setOpen] = useState("")
  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  const handleApprove = item => {
    const updateStatus = async item => {
      const response = await updateRevisionStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }
  const handleRevisionType = index => {
    if (revisionType?.index === index) {
      setRevisionType({ index: index, status: !revisionType?.status })
    } else {
      setRevisionType({ index: index, status: true })
    }
  }
  console.log("revisionType:", revisionType)
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Purchase Order View"
                breadcrumbObject={[
                  { title: "Procurement", link: "/procurement" },
                  {
                    title: "Purchase Order",
                    link: `/procurement-purchaseorder`,
                  },
                  {
                    title: fullUrl.includes(
                      "procurement-company-purchase-order"
                    )
                      ? "Company Purchase Order view"
                      : "Purchase Order view",
                    link: fullUrl.includes("procurement-company-purchase-order")
                      ? `/procurement-company-purchase-order/view/${viewId}`
                      : `/procurement-purchase-order/view/${viewId}`,
                  },
                ]}
              />
            )}
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className={`purchase-view-div po-new-wdt ${fromDashboard && "wdt-96"}`}>
                <div className="d-flex justify-content-between">
                  <div className="wdt-33">
                    <div className="uppercase-letter">
                      {loggedUser?.settings?.companyname
                        ? loggedUser?.settings?.companyname
                        : "Ever Rise"}
                    </div>
                    <div>
                      {loggedUser?.settings?.companyinfo
                        ? loggedUser?.settings?.companyinfo
                        : ""}
                    </div>
                  </div>
                  <div className="wdt-33">
                    <div className="d-flex justify-content-center">
                      {loggedUser?.settings?.companylogo ? (
                        <img
                          className="view-logo-po"
                          src={`${imgUrl}${loggedUser?.settings?.companylogo}`}
                          alt="logo"
                        />
                      ) : (
                        <img className="view-logo-po" src={Logo} alt="logo" />
                      )}
                    </div>
                  </div>
                  <div className="wdt-33">
                    <div className="text-end">
                      P.O. Box{" "}
                      {loggedUser?.settings?.companyzipcode
                        ? loggedUser?.settings?.companyzipcode
                        : ""}{" "}
                      {loggedUser?.settings?.state?.name
                        ? `${loggedUser.settings.state.name} - ${
                            loggedUser.settings.state.country?.name || ""
                          }`
                        : ""}
                    </div>
                    <div className="text-end">
                      Tel :{" "}
                      {loggedUser?.settings?.phone
                        ? "+" + loggedUser?.settings?.phone
                        : ""}
                    </div>
                    <div className="text-end">
                      Email :{" "}
                      {loggedUser?.settings?.companyemail
                        ? loggedUser?.settings?.companyemail
                        : ""}
                    </div>
                    <div className="text-end">
                      Website :{" "}
                      {loggedUser?.settings?.website
                        ? loggedUser?.settings?.website
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  Purchase Order
                </div>
                <div className="d-flex justify-content-center">
                  TRN NO :{" "}
                  {loggedUser?.settings?.vat_no
                    ? loggedUser?.settings?.vat_no
                    : ""}
                </div>
                <div className="d-flex">
                  <div className="wdt-60 me-5">
                    <div className="mr-border p-2">
                      To
                      <Row>
                        <Col sm={4}>Vendor ID</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger
                            ? revision?.ledger?.supplier?.suppliers_code
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>Vendor Name</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger
                            ? revision?.ledger?.supplier?.name
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>TRN No</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.vat_no
                            ? revision?.ledger?.supplier?.vat_no
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>PO Box No</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.po_box_no
                            ? revision?.ledger?.supplier?.po_box_no
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>Emirate</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.country?.name
                            ? revision?.ledger?.supplier?.country?.name
                            : "-"}{" "}
                          -{" "}
                          {revision?.ledger?.supplier?.country?.country?.name
                            ? revision?.ledger?.supplier?.country?.country?.name
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>Contact Person</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.contact?.name
                            ? revision?.ledger?.supplier?.country?.name
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>Contact Number</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.contact?.name
                            ? revision?.ledger?.supplier?.country?.name
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>Contact Mail</Col>
                        <Col sm={"auto"}>
                          :{" "}
                          {revision?.ledger?.supplier?.contact?.name
                            ? revision?.ledger?.supplier?.country?.name
                            : "-"}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="wdt-40">
                    <div> </div>
                    <div className="mr-border pt-3">
                      <Row>
                        <Col sm={4} className="text-end p-0">
                          P.O. NO :
                        </Col>
                        <Col sm={"auto"} className="ps-1">
                          {" "}
                          {revision?.code ? revision?.code : "-"}
                        </Col>
                      </Row>
                      <Row className="p-0">
                        <Col sm={4} className="text-end p-0">
                          Date :
                        </Col>
                        <Col sm={"auto"} className="ps-1">
                          {" "}
                          {revision?.created_at
                            ? moment(revision?.created_at).format("DD-MMM-YYYY")
                            : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4} className="text-end p-0">
                          RFQ REF :
                        </Col>
                        <Col sm={"auto"} className="ps-1">
                          {" "}
                          {revision?.rfq?.code ? revision?.rfq?.code : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4} className="text-end p-0">
                          PR NO :
                        </Col>
                        <Col sm={"auto"} className="ps-1">
                          {" "}
                          {revision?.code ? revision?.code : "-"}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                {revision?.materials?.length ? (
                  <>
                    <Row className="my-4">
                      <Col lg={12}>
                        <table className="estimation-table mb-4">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>ITEM CODE</th>
                              <th>DESCRIPTION</th>
                              <th>COST CODE</th>
                              <th className="text-end pe-4">QTY</th>
                              <th>UNIT</th>
                              <th className="text-end pe-4">UNIT PRICE</th>
                              <th className="text-end pe-4">% DISC</th>
                              <th className="text-end pe-4">LINE TOTAL</th>
                            </tr>
                          </thead>
                          <tbody>
                            {revision?.materials?.map((dt, index) => (
                              <tr key={`po_${index}`}>
                                <td>{index + 1}</td>
                                <td>{dt?.product?.product_code}</td>
                                <td>{dt?.product?.description}</td>
                                <td>-</td>
                                <td className="text-end pe-4">
                                  {NumberFormat(Number(dt?.po_quantity))}
                                </td>
                                <td>{dt?.product?.unit?.unit_code}</td>
                                <td className="text-end pe-4">
                                  {NumberFormat(Number(dt?.unit_price), desimalrange, desimalrange)}
                                </td>
                                <td className="text-end pe-4">-</td>
                                <td className="text-end pe-4">
                                  {NumberFormat(
                                    Number(dt?.po_quantity) *
                                      Number(dt?.unit_price),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              {/* <td></td>
                              <td></td> */}
                              <td colSpan={9} className="text-center">
                                ---nothing follows---
                              </td>
                              {/* <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td> */}
                            </tr>
                            {/* <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr> */}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
                {/* <Row>
                  <Col lg={6} className="main-heading">
                    Purchase Order
                  </Col>
                  <Col lg={6} className="d-flex justify-content-end">
                    <img className="view-logo" src={Logo} alt="logo" />
                  </Col>
                </Row>
                <Row className="pb-4">
                  <Col lg={6} className="py-3 ">
                    <div className={"supplier-td-head pt-2"}>From</div>
                    <div className={"supplier-td-body pt-2"}>Everrise</div>
                    <div className={"supplier-td-head pt-2"}>
                      No-6/23, Nesamani Nagar, Nagercoil.
                    </div>
                    <div className={"supplier-td-head pt-2"}>
                      Mobile: +98765432543
                    </div>
                  </Col>
                  <Col lg={6} className="py-3">
                    <div className={"supplier-td-head pt-2"}>To</div>
                    <div className={"supplier-td-body pt-2"}>
                      {revision?.supplier?.name}
                    </div>
                    <div className={"supplier-td-head pt-2"}>
                      {revision?.supplier?.address}
                    </div>
                    <div className={"supplier-td-head pt-2"}>
                      Mobile: {revision?.supplier?.contact_number}
                    </div>
                  </Col>
                </Row>
                <hr className="m-0" />
                <Row className="py-4">
                  {revision?.material_request_id != null && (
                    <Col lg={3} className="py-2 pb-4">
                      <div className="supplier-td-head">MR NO</div>
                      <div className="supplier-td-body">
                        {revision?.material_request_id?.material_requests_code}
                      </div>
                    </Col>
                  )}
                  {revision?.project_master != null && (
                    <Col lg={3} className="py-2 pb-4">
                      <div className="supplier-td-head">Project Code</div>
                      <div className="supplier-td-body">
                        {revision?.project_master?.project_code}
                      </div>
                    </Col>
                  )}
                  {revision?.project_master != null && (
                    <Col lg={3} className="py-2 pb-4">
                      <div className="supplier-td-head">Project Name</div>
                      <div className="supplier-td-body">
                        {revision?.project_master?.project_name}
                      </div>
                    </Col>
                  )}
                  <Col lg={3} className="py-2 pb-4">
                    <div className="supplier-td-head">Credit</div>
                    <div className="supplier-td-body">Project Lorem</div>
                  </Col>
                  <Col lg={3} className="py-2 pb-4">
                    <div className="supplier-td-head">Request Date</div>
                    <div className="supplier-td-body">
                      {moment(revision?.request_date).format("DD/MM/YYYY")}
                    </div>
                  </Col>
                  <Col lg={3} className="py-2 pb-4">
                    <div className="supplier-td-head">Exp. Delivery Date</div>
                    <div className="supplier-td-body">
                      {moment(revision?.exp_Delivery_date).format("DD/MM/YYYY")}
                    </div>
                  </Col>
                  <Col lg={3} className="py-2 pb-4">
                    <div className="supplier-td-head">Contact Person</div>
                    <div className="supplier-td-body">
                      {revision?.supplier?.name}
                    </div>
                  </Col>
                  <Col lg={3} className="py-2 pb-4">
                    <div className="supplier-td-head">Contact Number</div>
                    <div className="supplier-td-body">
                      {"+" + revision?.supplier?.contact_number}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={12}>
                    <table className="estimation-table mb-4">
                      <thead>
                        <tr>
                          <th>Sl.no</th>
                          <th>Product Code</th>
                          <th>Description</th>
                          <th>Unit</th>
                          <th>Qty</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {revision?.purchaseorder_lists?.map((dt, index) => (
                          <tr key={`po_${index}`}>
                            <td>{index + 1}</td>
                            <td>{dt?.product_code?.product_code}</td>
                            <td>{dt?.description}</td>
                            <td>{dt?.unit?.unit_code}</td>
                            <td>{dt?.quantity}</td>
                            <td>{dt?.price}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Col>
                  <Col sm={7}>
                    <Row className="pt-3 pay-terms">
                      <Col sm={8}>
                        <div>Payment Terms:</div>
                        <p className="pt-2 pay-terms">
                          {revision?.pay_terms}
                        </p>
                      </Col>
                    </Row>
                    <Row className="pt-3 pay-terms">
                      <Col sm={8}>
                        <div>Remarks:</div>
                        <p className="pt-2">
                          {revision?.remarks}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={5}>
                    <Row className="d-flex align-items-center py-3">
                      <Col sm={6} className="text-end">
                        Sub total
                      </Col>
                      <Col sm={6} className="po-view-text">
                        {revision?.sub_total}
                      </Col>
                    </Row>
                    {revision?.tax != 0 && (
                      <Row className="d-flex align-items-center py-3">
                        <Col sm={6} className="text-end">
                          VAT
                        </Col>
                        <Col sm={6} className="po-view-text">
                          {revision?.tax}%
                        </Col>
                      </Row>
                    )}
                    {revision?.discount != 0 && (
                      <Row className="d-flex align-items-center py-3">
                        <Col sm={6} className="text-end">
                          Discount
                        </Col>
                        <Col sm={6} className="po-view-text">
                          {revision?.discount}%
                        </Col>
                      </Row>
                    )}
                    {revision?.shipping_charge != 0 && (
                      <Row className="d-flex align-items-center py-3">
                        <Col sm={6} className="text-end">
                          Shipping Charge
                        </Col>
                        <Col sm={6} className="po-view-text">
                          {revision?.shipping_charge
                            ? revision?.shipping_charge
                            : 0}
                        </Col>
                      </Row>
                    )}
                    {revision?.other_charge != 0 && (
                      <Row className="d-flex align-items-center py-3">
                        <Col sm={6} className="text-end">
                          Other Charge
                        </Col>
                        <Col sm={6} className="po-view-text">
                          {revision?.other_charge ? revision?.other_charge : 0}
                        </Col>
                      </Row>
                    )}
                    <Row className="d-flex align-items-center py-3">
                      <Col sm={6} className="text-end dark-text">
                        Total Amount
                      </Col>
                      <Col sm={6} className="po-view-text">
                        {revision?.total_amount}
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
                <div className="contact-us d-flex align-items-end justify-content-between text-blue border-top mt-5 py-3 font-size-12">
                  <div className="font-bold-800">Contact Us</div>
                  <div>
                    <img
                      src={phoneIcon}
                      alt="location"
                      className="footer-logo"
                    />{" "}
                    +{loggedUser?.settings?.phone}
                  </div>
                  <div>
                    <img src={webIcon} alt="location" className="footer-logo" />{" "}
                    {loggedUser?.settings?.website}
                  </div>
                  <div>
                    <img
                      src={locationIcaon}
                      alt="location"
                      className="footer-logo"
                    />{" "}
                    {loggedUser?.settings?.companyaddress}
                  </div>
                </div>
              </div>
              {!fromDashboard && (
                <Row>
                  <Col lg={10}>
                    <div className="d-flex justify-content-end me-2 pe-2">
                      {/* pr-50 */}
                      <span></span>
                      {revision?.status === 1 && (
                        <Button
                          className="px-3 mb-3 btn-secondary me-2"
                          form={`ev-form`}
                          color={"secondary"}
                          onClick={() =>
                            navigate(
                              `/procurement-purchase-order/edit/${revision?.id}`
                            )
                          }
                        >
                          Edit
                        </Button>
                      )}
                      <Button
                        form={`supplier-form`}
                        color={"primary"}
                        className={"px-2 mb-3 btn btn-primary"}
                        onClick={() => downloadpo(viewId, "po.pdf")}
                      >
                        Print
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewPurchaseOrderVoucher
